@file:Suppress("DEPRECATION")

package org.example.zone360.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.JustifyContent
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onMouseDown
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.delay
import org.example.zone360.pages.coachDetails.sessionAllDetails.WaveBarStyle
import org.example.zone360.pages.coachDetails.sessionAllDetails.WaveformStyle
import org.example.zone360.theme.Palette
import org.example.zone360.theme.SitePalette
import org.example.zone360.theme.toSitePalette
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.StylePropertyValue
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Input
import org.w3c.dom.HTMLVideoElement
import kotlin.random.Random

@Composable
fun AudioProgressSliderCustom(
    progress: Float, // Current audio progress as a percentage (0.0 to 1.0)
    onProgressChange: (Float) -> Unit, // Called when the user drags the slider
    width: CSSLengthOrPercentageNumericValue = 100.percent,
) {
    // Create a Slider UI element
    Input(
        type = InputType.Range,
        attrs = Modifier.height(2.px).width(width).toAttrs {
            value((progress * 100).toString())
//            attr("value", (progress * 100).toString()) // Multiply by 100 for percentage
            attr("min", "0")
            attr("max", "100")
            attr("step", "1")
            onInput {
                // Handle slider input change
                val newProgress = it.value?.toFloat()
                if (newProgress != null) {
                    // Update the progress based on the slider position
                    onProgressChange(newProgress / 100) // Convert back to 0.0 - 1.0 range
                }
            }
        },
    )
}
@Composable
fun VideoProgressSliderCustom(
    progress: Float,
    onProgressChange: (Float) -> Unit,
    modifier: Modifier = Modifier,
    highlightSegments: List<Pair<Float, Float>> = emptyList(),
    videoDuration: Double = 0.0,
    selectedKeyword: String? = null,
    keywordSegments: List<Pair<Float, Float>> = emptyList()
) {
    // Calculate the gradient stops for highlighted segments
    val gradientStops = remember(highlightSegments, keywordSegments, selectedKeyword) {
        if (highlightSegments.isEmpty() && keywordSegments.isEmpty()) {
            "#e0e0e0" // Default color when no highlights
        } else {
            buildString {
                append("#e0e0e0 0%")

                // First add regular highlight segments (non-keyword)
                highlightSegments.forEach { (start, end) ->
                    append(", #e0e0e0 ${(start * 100).toInt()}%")
                    append(", #FFA500 ${(start * 100).toInt()}%") // Orange for regular highlights
                    append(", #FFA500 ${(end * 100).toInt()}%")
                    append(", #e0e0e0 ${(end * 100).toInt()}%")
                }

                // Then add keyword segments (if a keyword is selected)
                if (selectedKeyword != null) {
                    keywordSegments.forEach { (start, end) ->
                        append(", #e0e0e0 ${(start * 100).toInt()}%")
                        append(", #FF0000 ${(start * 100).toInt()}%") // Red for keyword highlights
                        append(", #FF0000 ${(end * 100).toInt()}%")
                        append(", #e0e0e0 ${(end * 100).toInt()}%")
                    }
                }
                append(", #e0e0e0 100%")
            }
        }
    }

    Input(
        type = InputType.Range,
        attrs = modifier
            .height(4.px)
            .styleModifier {
                property("appearance", "none")
                property("width", "100%")
                property("height", "4px")
                property("border-radius", "2px")
                property("background", "linear-gradient(to right, $gradientStops)")

                // Thumb style
                property(
                    "&::-webkit-slider-thumb",
                    StylePropertyValue(
                        """
                        -webkit-appearance: none;
                        appearance: none;
                        width: 15px;
                        height: 15px;
                        background: #FF0000;
                        border-radius: 50%;
                        cursor: pointer;
                        border: none;
                        z-index: 2;
                        position: relative;
                        """
                    )
                )

                // Track style
                property(
                    "&::-webkit-slider-runnable-track",
                    StylePropertyValue(
                        """
                        -webkit-appearance: none;
                        height: 4px;
                        border-radius: 2px;
                        """
                    )
                )
            }
            .toAttrs {
                value(progress * 100)
                attr("min", "0")
                attr("max", "100")
                attr("step", "0.1")
                onInput {
                    val newProgress = it.value?.toFloat()
                    if (newProgress != null) {
                        onProgressChange(newProgress / 100)
                    }
                }
            }
    )
}



@Composable
fun VideoProgressSliderCustom1(
    progress: Float,
    onProgressChange: (Float) -> Unit,
    modifier: Modifier = Modifier,
    timeSegments: List<Triple<Float, Float, String>> = emptyList(), // (start, end, color)
    videoDuration: Double = 0.0,
    isThumbMove : Boolean = true
) {
    val defaultColor = "#e0e0e0"
    val highlightColor = "#FF5722"

    // Calculate the gradient stops for time segment
    val gradientStops = remember(timeSegments) {
        if (timeSegments.isEmpty()) {
            defaultColor
        } else {
            buildString {
                append("$defaultColor 0%")

                val sortedSegments = timeSegments.sortedBy { it.first }
                var lastEnd = 0f

                sortedSegments.forEach { (start, end, _) ->
                    val startPercent = (start * 100).asDynamic().toFixed(2)
                    val endPercent = (end * 100).asDynamic().toFixed(2)
                    val lastEndPercent = (lastEnd * 100).asDynamic().toFixed(2)


                    if (start > lastEnd) {
                        append(", $defaultColor $lastEndPercent%")
                        append(", $defaultColor $startPercent%")
                    }

                    append(", $highlightColor $startPercent%")
                    append(", $highlightColor $endPercent%")

                    lastEnd = end
                }

                if (lastEnd < 1f) {
                    val lastEndPercent = (lastEnd * 100).asDynamic().toFixed(2)
                    append(", $defaultColor $lastEndPercent%")
                    append(", $defaultColor 100%")
                }
            }
        }
    }


    val inputModifier = modifier
        .margin(top = 30.px)
        .height(8.px)

        .styleModifier {
            property("appearance", "none")
            property("width", "100%")
            property("height", "8px")
            property("border-radius", "2px")
            property("background", "linear-gradient(to right, $gradientStops)")

            property(
                "&::-webkit-slider-thumb",
                StylePropertyValue(
                    """
                -webkit-appearance: none;
                appearance: none;
                width: 15px;
                height: 15px;
                background: #FF0000 !important;
                border-radius: 50%;
                cursor: pointer;
                border: none;
                position: relative;
                """
                )
            )

            property(
                "&::-webkit-slider-runnable-track",
                StylePropertyValue(
                    """
                -webkit-appearance: none;
                height: 8px;
                border-radius: 2px;
                """
                )
            )
        }
    Input(
        type = InputType.Range,
        attrs = inputModifier.toAttrs {
            value(progress * 100)
            attr("min", "0")
            attr("max", "100")
            attr("step", "any")

            if (isThumbMove) {
                onInput {
                    val newProgress = it.value?.toFloat()
                    if (newProgress != null) {
                        onProgressChange(newProgress / 100)
                    }
                }
            } else {

                style {
                    property("pointer-events", "none")
                }
            }
        }
    )
}

@Composable
fun DraggableRangeSlider(
    modifier: Modifier = Modifier,
    initialMinPercent: Double = 0.0,
    initialMaxPercent: Double = 0.5,
    width: CSSLengthOrPercentageNumericValue = 100.percent,
    widthPx: Double = 300.0,
    onRangeChange: (minPercent: Double, maxPercent: Double) -> Unit = { _, _ -> }
) {
    var minPercent by remember { mutableStateOf(initialMinPercent) }
    var maxPercent by remember { mutableStateOf(initialMaxPercent) }
    var draggingThumb by remember { mutableStateOf<String?>(null) }
    var draggingRange by remember { mutableStateOf(false) }
    var dragStartX by remember { mutableStateOf(0.0) }

    // Sync with external changes (e.g., from input fields)
    LaunchedEffect(initialMinPercent, initialMaxPercent) {
        minPercent = initialMinPercent
        maxPercent = initialMaxPercent
    }

    val sitePalette = ColorMode.current.toSitePalette()

    Box(
        modifier = modifier
            .width(width)
            .height(36.px)
            .position(Position.Relative)
    ) {
        // Background track
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .height(6.px)
                .backgroundColor(Colors.LightGray)
                .position(Position.Absolute)
                .top(50.percent)
                .transform { translateY((-50).percent) }
                .borderRadius(4.px)
        )

        // Highlighted range
        Box(
            modifier = Modifier
                .position(Position.Absolute)
                .top(50.percent)
                .left((minPercent * 100).percent)
                .width(((maxPercent - minPercent) * 100).percent)
                .height(6.px)
                .transform { translateY((-50).percent) }
                .backgroundColor(sitePalette.primary.rgb)
                .borderRadius(4.px)
                .zIndex(2)
                .cursor(if (draggingRange) Cursor.Grabbing else Cursor.Grab)
                .onMouseDown {
                    it.preventDefault()
                    draggingRange = true
                    dragStartX = it.clientX.toDouble()
                }
        )

        // Min Thumb
        Box(
            modifier = Modifier
                .position(Position.Absolute)
                .top(50.percent)
                .left((minPercent * 100).percent)
                .transform { translate((-50).percent, (-50).percent) }
                .size(18.px)
                .backgroundColor(Colors.White)
                .borderRadius(50.percent)
                .border(2.px, color = sitePalette.primary.rgb, style = LineStyle.Solid)
                .zIndex(3)
                .cursor(if (draggingThumb == "min") Cursor.Grabbing else Cursor.Pointer)
                .onMouseDown {
                    it.preventDefault()
                    draggingThumb = "min"
                    dragStartX = it.clientX.toDouble()
                }
        )

        // Max Thumb
        Box(
            modifier = Modifier
                .position(Position.Absolute)
                .top(50.percent)
                .left((maxPercent * 100).percent)
                .transform { translate((-50).percent, (-50).percent) }
                .size(18.px)
                .backgroundColor(Colors.White)
                .borderRadius(50.percent)
                .border(2.px, color = sitePalette.primary.rgb, style = LineStyle.Solid)
                .zIndex(3)
                .cursor(if (draggingThumb == "max") Cursor.Grabbing else Cursor.Pointer)
                .onMouseDown {
                    it.preventDefault()
                    draggingThumb = "max"
                    dragStartX = it.clientX.toDouble()
                }
        )
    }

    // Global drag handling
    LaunchedEffect(Unit) {
        window.onmouseup = {
            draggingThumb = null
            draggingRange = false
            false
        }

        window.onmousemove = { e ->
            if (draggingThumb == null && !draggingRange) {

            } else {

                e.preventDefault()
                val dx = e.clientX - dragStartX
                val percentChange = dx / widthPx

                if (draggingThumb == "min") {
                    minPercent = (minPercent + percentChange).coerceIn(0.0, maxPercent - 0.01)
                    dragStartX = e.clientX.toDouble()
                    onRangeChange(minPercent, maxPercent)
                }

                if (draggingThumb == "max") {
                    maxPercent = (maxPercent + percentChange).coerceIn(minPercent + 0.01, 1.0)
                    dragStartX = e.clientX.toDouble()
                    onRangeChange(minPercent, maxPercent)
                }

                if (draggingRange) {
                    if (minPercent + percentChange >= 0 && maxPercent + percentChange <= 1.0) {
                        minPercent += percentChange
                        maxPercent += percentChange
                        dragStartX = e.clientX.toDouble()
                        onRangeChange(minPercent, maxPercent)
                    }
                }
            }
        }
    }
}


@Composable
fun WaveformRangeSlider(
    modifier: Modifier = Modifier,
    widthPx: Double = 600.0,
    heightPx: Double = 40.0,
    audioDuration: Double = 0.0,
    initialMinPercent: Double,
    initialMaxPercent: Double,
    onRangeChange: (minPercent: Double, maxPercent: Double) -> Unit = { _, _ -> },
    sitePalette: SitePalette
) {
    var minPercent by remember { mutableStateOf(initialMinPercent) }
    var maxPercent by remember { mutableStateOf(initialMaxPercent) }
    var draggingThumb by remember { mutableStateOf<String?>(null) }
    var draggingRange by remember { mutableStateOf(false) }
    var dragStartX by remember { mutableStateOf(0.0) }

    // ✅ Sync with external changes from input fields
    LaunchedEffect(initialMinPercent, initialMaxPercent) {
        minPercent = initialMinPercent
        maxPercent = initialMaxPercent
    }

    val clampedBarsCount = when {
        audioDuration > 3600 -> 2000
        audioDuration > 1800 -> 1000
        audioDuration > 600 -> 500
        audioDuration > 300 -> 300
        else -> if (window.screen.width < 375) 50 else 100
    }

    val waveformData by remember { mutableStateOf(generateWaveformData(clampedBarsCount)) }

    Box(
        modifier = modifier
            .width(100.percent)
            .height(heightPx.px)
            .padding(leftRight = 9.px)
            .then(WaveformStyle.toModifier())
            .position(Position.Relative)
            .overflow(Overflow.Hidden)
    ) {
        // Waveform bars
        Row(
            modifier = Modifier.fillMaxWidth().height(90.percent),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceEvenly
        ) {
            waveformData.forEach { height ->
                Box(
                    modifier = WaveBarStyle.toModifier()
                        .width(
                            when {
                                clampedBarsCount >= 2000 -> 0.2.px
                                clampedBarsCount >= 1000 -> 0.6.px
                                else -> 0.8.px
                            }
                        )
                        .height((height * 90).percent)
                        .backgroundColor(Palette.WaveBarColor.rgbLight)
                )
            }
        }

        // Active range box
        Box(
            modifier = Modifier
                .position(Position.Absolute)
                .top(0.px)
                .left((minPercent * 100).percent)
                .width(((maxPercent - minPercent) * 100).percent)
                .height(100.percent)
                .backgroundColor(sitePalette.primary.rgb.copyf(alpha = 0.10f))
                .border(2.px, LineStyle.Solid, sitePalette.primary.rgb)
                .borderRadius(6.px)
                .cursor(if (draggingRange) Cursor.Grabbing else Cursor.Grab)
                .zIndex(2)
                .onMouseDown {
                    it.preventDefault()
                    draggingRange = true
                    dragStartX = it.clientX.toDouble()
                }
        )

        // Left Thumb
        Box(
            modifier = Modifier
                .position(Position.Absolute)
                .top(0.px)
                .left((minPercent * 100).percent)
                .transform {
                    if (minPercent <= 0.0) translateX(0.px) else translateX((-5).px)
                }
                .height(100.percent)
                .width(10.px)
                .backgroundColor(sitePalette.primary.rgb)
                .borderRadius(4.px)
                .cursor(if (draggingThumb == "left") Cursor.Grabbing else Cursor.EwResize)
                .zIndex(3)
                .onMouseDown {
                    it.preventDefault()
                    draggingThumb = "left"
                    dragStartX = it.clientX.toDouble()
                }
        )

        // Right Thumb
        Box(
            modifier = Modifier
                .position(Position.Absolute)
                .top(0.px)
                .left((maxPercent * 100).percent)
                .transform { translateX((-5).px) }
                .height(100.percent)
                .width(10.px)
                .backgroundColor(sitePalette.primary.rgb)
                .borderRadius(4.px)
                .cursor(if (draggingThumb == "right") Cursor.Grabbing else Cursor.EwResize)
                .zIndex(3)
                .onMouseDown {
                    it.preventDefault()
                    draggingThumb = "right"
                    dragStartX = it.clientX.toDouble()
                }
        )
    }

    // ✅ Drag logic
    LaunchedEffect(Unit) {
        window.onmouseup = {
            draggingThumb = null
            draggingRange = false
            false
        }

        window.onmousemove = { e ->
            if (draggingThumb == null && !draggingRange) {

            }else {    e.preventDefault()
                val dx = e.clientX - dragStartX
                val percentChange = dx / widthPx

                if (draggingThumb == "left") {
                    minPercent = (minPercent + percentChange).coerceIn(0.0, maxPercent - 0.01)
                    dragStartX = e.clientX.toDouble()
                    onRangeChange(minPercent, maxPercent)
                }

                if (draggingThumb == "right") {
                    maxPercent = (maxPercent + percentChange).coerceIn(minPercent + 0.01, 1.0)
                    dragStartX = e.clientX.toDouble()
                    onRangeChange(minPercent, maxPercent)
                }

                if (draggingRange) {
                    if (minPercent + percentChange >= 0 && maxPercent + percentChange <= 1.0) {
                        minPercent += percentChange
                        maxPercent += percentChange
                        dragStartX = e.clientX.toDouble()
                        onRangeChange(minPercent, maxPercent)
                    }
                }
            }
        }
    }
}

// Shared waveform height generator
private fun generateWaveformData(bars: Int): List<Float> {
    return List(bars) { Random.nextFloat() * 0.7f + 0.3f }
}


